import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped({
  internal_id: { property: 'internalID' },
})
export class JobReference extends Mappable {
  id!: number
  internalID!: string

  static create<Data>(attrs: Data) {
    return new JobReference().map(attrs)
  }
}
